export default __webpack_public_path__ + "static/media/06_photo.c41276fd.jpg";